import { render, staticRenderFns } from "./PartTypeDonut.vue?vue&type=template&id=137d0812"
import script from "./PartTypeDonut.vue?vue&type=script&lang=js"
export * from "./PartTypeDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports